import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  年齡組: {
    "<18歲": 0,
    "18-24歲": 1,
    "25-34歲": 2,
    "35-44歲": 3,
    "45-54歲": 4,
    "55-64歲": 5,
    ">=65歲": 6,
    "-": 7,
  },
};

export const AgeToBMI = {
  label: "年齡 vs BMI",
  key: "AgeToBMI",
  path: "BMI/AgeToBMI",
  api: "TCS_V_BMIItemsV",
  render: (options) => <Diagram.BMI.AgeToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "年齡組",
      field: "年齡組",
      header: "",
    },
  ],
  groupOrders,
  levelColumns,
  columns: [],
};
